import {
  SET_MODAL_SHOW_SUCCESS,
  SEND_PARTICIPANT_DATA,
  SEND_PARTICIPANT_DATA_ERROR,
  SEND_PARTICIPANT_DATA_SUCCESS,
  SET_SHOW_SUCCESS_TOAST
} from './AddParticipantModal.actions'

const initialState = {
  error: false,
  loading: true,
  showAddParticipantModal: false,
  showSuccessToast: false
}

/**
 * The reducer for the Participants List
 */
const addParticipantModalReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_SHOW_SUCCESS_TOAST: {
      return {
        ...state,
        showSuccessToast: payload.showSuccessToast
      }
    }
    case SET_MODAL_SHOW_SUCCESS: {
      return {
        ...state,
        showAddParticipantModal: payload.showAddParticipantModal,
        loading: false,
        error: false
      }
    }
    case SEND_PARTICIPANT_DATA: {
      return { ...state, loading: true, error: false }
    }
    case SEND_PARTICIPANT_DATA_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case SEND_PARTICIPANT_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        showSuccessToast: true
      }
    }
    default: {
      return state
    }
  }
}

export default addParticipantModalReducer
